module.exports = __webpack_public_path__ + "img/bg-icon5.0a09d4a5.png";